import SelectTemplateCategory, {renderTemplateCategory} from '@/modules/templates/components/SelectTemplateCategory';
import {renderDateView} from '@/modules/templates/components/TemplateViewDate';
import {renderTemplatesName} from '@/modules/templates/components/Registers/TemplatesNameCell';
import {renderTemplatesDescription} from '@/modules/templates/components/TemplatesDescriptionCell';
import  {renderTemplateSections} from '@/modules/templates/components/Registers/TemplateSectionsDrawer';
import SelectTemplateLanguage from '@/modules/templates/components/SelectTemplateLanguage';
import TemplateReportTypeSelect from '@/modules/templates/components/TemplateReportTypeSelect';
import SelectFacilities from '@/modules/clients/components/SelectFacilitiesType';

export const fields = [
  {
    key: 'name',
    label: 'form.title',
    placeholder: 'form.placeholderTemplateTitle',
    required: true,
    onlyEdit: true,
    colSpan: 2
  },
  {
    key: 'name',
    onlyView: true,
    renderView: renderTemplatesName
  },
  {
    key: 'description',
    onlyView: true,
    renderView: renderTemplatesDescription
  },
  {
    key: 'category',
    label: 'form.category',
    placeholder: 'form.placeholderTemplateCategory',
    renderView: renderTemplateCategory,
    required: true,
    widget: SelectTemplateCategory,
    onlyEdit: true,
    colSpan: 1.5
  },
  {
    key: 'language',
    label: 'form.language',
    required: true,
    widget: SelectTemplateLanguage,
    onlyEdit: true,
    colSpan: 0.5,
    initialValue: 'es'
  },
  {
    key: 'title',
    label: 'form.registerTitle',
    placeholder: 'form.placeholderRegisterTitle',
    required: true,
    onlyEdit: true,
    colSpan: 1
  },
  {
    key: 'reportType',
    label: 'form.reportType',
    placeholder: 'form.placeholderTemplateReportType',
    required: true,
    widget: TemplateReportTypeSelect,
    onlyEdit: true,
    colSpan: 1
  },
  {
    key: 'registerType',
    label: 'facilityType',
    placeholder: 'placeholderFacilityType',
    colSpan: 1,
    onlyEdit: true,
    widget: SelectFacilities,
    widgetProps: {
      isTemplate: true,
    }
  },
  {
    key: 'description',
    label: 'form.description',
    placeholder: 'form.placeholderTemplateDescription',
    widget: 'textarea',
    widgetProps: {autoSize: {minRows: 5, maxRows: 12}},
    className: 'form-view-mode-vertical-item',
    onlyEdit: true,
    colSpan: 2
  },
  {
    key: 'sections',
    className: 'mix-sections-cmp',
    onlyView: true,
    renderView: renderTemplateSections,
  },
  {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    dataIndex: 'createdAt',
    responsive: ['lg'],
    renderView: renderDateView,
    className: 'hidden'
  },
  {
    key: 'updatedAt',
    label: 'updatedAt',
    type: 'date',
    dataIndex: 'updatedAt',
    responsive: ['lg'],
    renderView: renderDateView,
    className: 'hidden'
  },
];
